<template>
  <div>
    <p>Betreiber und verantwortlich für die Inhalte dieses Planen-Konfigurators ist:</p>
    <p>
      {{contact.name.content}}<br>
      {{contact.company.content}}<br>
      {{contact.street.content}} {{contact.number.content}}<br>
      {{contact.zip.content}} {{contact.city.content}}<br>
      {{contact.country.content}}
    </p>
    <p>
      Tel.: {{contact.phone.content}}<br>
      Fax: {{contact.fax.content}}<br>
      E-Mail: {{contact.mail.content}}
    </p>
    <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE175032181</p>
    <p>Plattform der EU-Kommission zur Online-Streitbeilegung:
      <a href="https://ec.europa.eu/consumers/odr" class="kub-color">https://ec.europa.eu/consumers/odr</a>
    </p>
    <p>Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder verpflichtet noch bereit.</p>
  </div>
</template>

<script>
import DataContact from '../../data/general/contact'

export default {
  data () {
    return {
      contact: DataContact.contact
    }
  }
}
</script>

<style>
</style>
